import React, { useEffect } from "react";
import { useHistory } from "react-router";

import { defaultState } from "../components/contracts/ContractEditor";
import { ScreenContainer } from "../components/wombat-ui";
import { GET_VIEWER } from "../graphql/hooks/queries/useGetViewer";

import useInsertContractTemplate from "../hooks/useInsertContractTemplate";
import useTranslations from "../hooks/useTranslations";
import useViewer from "../hooks/useViewer";

type NewContractTemplateScreenProps = {};

const NewContractTemplateScreen: React.FC<NewContractTemplateScreenProps> = ({}) => {
  const history = useHistory();
  const t = useTranslations();
  const {
    company: { id: companyId },
  } = useViewer();

  const [insertContractTemplate] = useInsertContractTemplate({
    refetchQueries: [{ query: GET_VIEWER }],
  });

  useEffect(() => {
    insertContractTemplate({
      variables: {
        input: {
          title: t("contracts.newContractTemplateTitle") as string,
          body: JSON.stringify({
            initialState: defaultState,
            variables: [],
          }),
          signatories: [],
          companyId,
        },
      },
    })
      .then((res) => {
        history.replace(
          `/contracts/templates/edit/${res.data.insertContractTemplate.contractTemplate.id}`
        );
      })
      .catch((e) => {
        console.error(e);
        history.push("/contracts");
      });
  }, []);

  return <ScreenContainer loading />;
};

export default React.memo(NewContractTemplateScreen);
